import {RecordForm} from '../forms/RecordForm';
import {useCustomer} from '../hooks/useCustomer.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";
import {Customer} from "../types.ts";

export const AddPage = () => {
    const { createRecord } = useCustomer();

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as Customer} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};